import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

import useCustomerEditModal from "hooks/useCustomerEditModal"

const Container = styled.div`
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #2db2c8;
  }
`

interface CustomerAddressProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const CustomerAddress = ({ cell }: CustomerAddressProps) => {
  const { onShowEditCustomerModal, renderEditCustomerModal } = useCustomerEditModal()
  const CustomerAddress = cell.getValue().value as string
  const customerId: number | null = cell.row.original.rowSettings.item.client_id
  const isInstalled = cell.row.original.rowSettings.item.phisical_status === "installed"

  const handleCustomerClick = () => {
    if (!customerId) return

    onShowEditCustomerModal(customerId)
  }

  const getCustomerAddress = () => {
    if (!isInstalled) {
      return ""
    }

    if (CustomerAddress && customerId) {
      return CustomerAddress
    }

    return ""
  }

  return (
    <>
      <Container onClickCapture={handleCustomerClick}>{getCustomerAddress()}</Container>
      {renderEditCustomerModal()}
    </>
  )
}
